import Vue from "vue";
Vue.filter("negative", (value) => {
  if (value !== undefined) {
    const format = (vl) =>
      parseFloat(vl).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL",
      });
    return value < 0 ? `(${format(value * -1)})` : format(value);
  }
});
